var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showOverlay
        ? _c("div", {
            staticClass: "overlay",
            attrs: { "aria-hidden": "true", tabindex: "-1" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          })
        : _vm._e(),
      _c("div", {
        staticClass: "spotlight-highlight",
        style: _vm.highlightStyle,
      }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }